<template>
  <div id="top">
    <Nav></Nav>
    <mainvisual></mainvisual>
    <!-- <kick></kick> -->
    <mission></mission>
    <about></about>
    <technology></technology>
    <member></member>
    <media></media>
    <sponsor></sponsor>
    <contact></contact>
    <press></press>
  </div>
</template>

<script>
import Nav from "../components/Nav";
import Mainvisual from "../components/Mainvisual";
// import Kick from "../components/Kick";
import Mission from "../components/Mission";
import About from "../components/About";
import Technology from "../components/Technology";
import Member from "../components/Member";
import Media from "../components/Media";
import Sponsor from "../components/Sponsor";
import Contact from "../components/Contact";
import Press from "../components/Press";
export default {
  components: {
    Nav,
    Mainvisual,
    // Kick,
    Mission,
    About,
    Technology,
    Member,
    Media,
    Sponsor,
    Contact,
    Press
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
.fade-enter-active,
.fade-leave-active {
  will-change: opacity;
  transition: opacity 225ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/Top.vue